module.exports = "/images/vendor/desiigner-svg/svg/places/pottery.svg?132467d0757a342a0419e3bec0189ecd";